// Salário Base = componente marcado explicitamente (flags: { id: true }), no máximo um por categoria.
// Sem nenhuma marcação na categoria: o componente fixo de Salário cujo rótulo é "Salário Base".
// Nunca por posição: outros fixos de Salário (ex.: Adiantamento) mantêm o próprio valor.
const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const isBaseSalaryItem = (it, { flags = {}, label, isSalary, anyFlag } = {}) => {
  if (!it || it.source !== "fixed" || it.is_discount || !isSalary) return false;
  if (flags[it.id]) return true;
  if (anyFlag) return false;
  return norm(label ?? it.label).startsWith("salario base");
};

// Há marcação explícita entre os itens dessa linha/categoria?
export const hasBaseFlag = (items = [], flags = {}) => items.some((it) => flags[it.id]);
